export default __webpack_public_path__ + "static/abstract-blocks-left-d3a2ddc09f801e5c63d229039c2744ca.svg";